/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-audit-summary.reducer';

export const PharmacyAuditSummaryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyAuditSummaryEntity = useAppSelector(state => state.pharmacyAuditSummary.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyAuditSummaryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.detail.title">PharmacyAuditSummary</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.endDate}</dd>
          <dt>
            <span id="discrepancyLoss">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.discrepancyLoss">Discrepancy Loss</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.discrepancyLoss}</dd>
          <dt>
            <span id="discrepancyGain">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.discrepancyGain">Discrepancy Gain</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.discrepancyGain}</dd>
          <dt>
            <span id="quantityLost">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.quantityLost">Quantity Lost</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.quantityLost}</dd>
          <dt>
            <span id="quantityFound">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.quantityFound">Quantity Found</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.quantityFound}</dd>
          <dt>
            <span id="auditStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.auditStatus">Audit Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.auditStatus}</dd>
          <dt>
            <span id="auditOutcome">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.auditOutcome">Audit Outcome</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.auditOutcome}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.cursor}</dd>
          <dt>
            <span id="newSync">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.newSync">New Sync</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.newSync ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.pharmacy ? pharmacyAuditSummaryEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.lossBill">Loss Bill</Translate>
          </dt>
          <dd>{pharmacyAuditSummaryEntity.lossBill ? pharmacyAuditSummaryEntity.lossBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-audit-summary" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-audit-summary/${pharmacyAuditSummaryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyAuditSummaryDetail;
